import { render } from "./DireccionesSection.vue?vue&type=template&id=03ff79bf"
import script from "./DireccionesSection.vue?vue&type=script&lang=js"
export * from "./DireccionesSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__